<template>
  <div class="service-downloads">
    <loader :loading="loading.categories"></loader>

    <div v-show="!loading.categories"
         :class="[{'visible-level-3': hasChildren(selection[2])},'max-level-'+selectionLevel]"
         class="categories-selection">


      <div class="row flex-row">
        <div class="col-sm-12">
          <div class="wrapper">
            <div class="headline h3">{{$t("service_download.select_info")}}</div>
            <div ref="categorie-level0" class="categories categorie-level0">
              <transition-group class="service-list list-horizontal" name="slide-fade" tag="ul">
                <li v-for="category in categories"
                    :key="category.id || category.name "
                    :class="{'active':selection[0] == category}" class="service-list-item"
                    v-on:click="selectCategory(category)">
                  <div>
                    <figure v-if="category.image">
                      <img :src="category.image"
                           alt="">
                    </figure>
                    <span>{{category.title}}</span>
                  </div>
                </li>
              </transition-group>
            </div>
          </div>
        </div>
        <div class="col-sm-8">
          <div v-if="selection[0] && hasChildren(selection[0])" class="wrapper">
            <div class="row flex-row">
              <transition name="category">
                <div v-show="selectionLevel < 1"
                     :class="{'hidden':hasChildren(selection[2]), 'has-children': hasChildren(selection[0])}"
                     class="col-sm-6 category-column">

                  <div v-if="selection[0]" ref="categorie-level1" class="categories categorie-level1">
                    <div class="headline">{{$t("service_download.select_productgroup")}}</div>
                    <div class="category-actions visible-xs">
                      <div class="btn btn-parent" @click="selectionBack(0)"><i
                          class="icon si-nav-parent icon-xs"></i><span>zurück</span></div>
                    </div>
                    <div v-bar class="scroll-content">
                      <transition-group class="service-list" mode="in-out" name="slide-fade" tag="ul">
                        <li v-for="category in getChildren(selection[0])"
                            :key="category.id || category.name "
                            :class="{'active':selection[1] == category}"
                            class="service-list-item">
                          <div v-on:click="selectCategory(category)">{{category.title}}
                          </div>
                        </li>
                      </transition-group>
                    </div>
                  </div>
                </div>
              </transition>
              <transition mode="out-in" name="category">
                <div v-show="selectionLevel < 2"
                     :class="{ 'has-children':hasChildren(selection[1])}" class="col-sm-6 category-column">


                  <div v-if="selection[1]" class="categories categorie-level2">
                    <div class="headline">{{$t("service_download.select_product")}}</div>
                    <div class="category-actions visible-xs">
                      <div class="btn btn-parent" @click="selectionBack(1)"><i
                          class="icon si-nav-parent icon-xs"></i><span>{{$t("back")}}</span>
                      </div>
                      <div class="btn btn-root" @click="selectionBack(0)"><i
                          class="icon si-nav-back icon-xs"></i><span></span></div>
                    </div>
                    <div class="parent-category">
                      {{selection[1].name}}
                    </div>
                    <service-downloads-products
                        :categories="getChildren(selection[1])"
                        :activeCategory="selection[2]"
                        @selectCategory="selectCategory"
                    />
                  </div>

                </div>
              </transition>
              <transition mode="out-in" name="category">
                <div v-show="selectionLevel >= 2"
                     :class="{ 'has-children':hasChildren(selection[2])}"
                     class="col-sm-6 category-column">


                  <div v-if="selection[2]" ref="categorie-level3"
                       class="categories categorie-level3">
                    <div class="headline">{{$t("service_download.select_product")}}</div>
                    <div class="category-actions visible-xs">
                      <div class="btn btn-parent" @click="selectionBack(2)"><i
                          class="icon si-nav-parent icon-xs"></i><span>{{$t("back")}}</span>
                      </div>
                      <div class="btn btn-root" @click="selectionBack(0)"><i
                          class="icon si-nav-back icon-xs"></i><span></span></div>
                    </div>
                    <div class="parent-category">
                      {{selection[2].name}}
                    </div>
                    <transition-group class="service-list" name="list" tag="ul">
                      <li v-for="category in getChildren(selection[2])"
                          :key="category.id || category.name"
                          :class="{'active':selection[3] == category}"
                          class="service-list-item">
                        <div v-on:click="selectCategory(category)">{{category.title}}</div>
                      </li>
                    </transition-group>
                  </div>
                </div>
              </transition>
            </div>
          </div>

        </div>

        <div class="col-sm-4">
          <div v-show="hasValidSelection" class="wrapper wrapper-filter">
            <div v-if="hasValidSelection" class="categories category-filter">
              <div aria-controls="navbar" aria-expanded="false" class="headline collapsed"
                   data-target="#download-filter"
                   data-toggle="collapse">{{$t("service_download.select_type")}}

                <div
                    class="navbar-toggle ">
                  <span class="sr-only">Toggle Filter</span>
                  <span class="icon-bar"></span>
                  <span class="icon-bar"></span>
                  <span class="icon-bar"></span>
                  <span class="icon icon-close"></span>
                </div>

              </div>
              <div id="download-filter" class="filter-selection collapse">
                <loader :loading="loading.types" class="loading-container-overlay"></loader>
                <transition-group class="" name="types" tag="div">
                  <div v-for="f in filter" :key="f.id" class="checkbox checkbox-styled">
                    <input :id="'filter-catalog-'+f.id" v-model="filterSelection" :value="f.id"
                           type="checkbox">
                    <label :for="'filter-catalog-'+f.id">{{$t("service_download.types."+f.id)}}</label>
                  </div>

                </transition-group>
                <button v-show="filterSelection.length > 0" class="btn btn-action action-remove-filter"
                        @click="resetFilterSelection()">
                  {{$t("service_download.filter_sorting.filter_remove")}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="actions">
      <div class="row">
        <div class="col-sm-12">
          <div class=" pull-right result-count">
                                            <span v-show="loading.resultsCount===false"
                                                  class="result-count-display">
                                                {{resultsCount}}
                                            </span>
            <span v-show="resultsCount !== null && loading.resultsCount===false">&nbsp;{{$t("service_download.result.count_media")}}</span>
            <button :disabled="!hasValidSelection" class="btn btn-primary btn-search" @click="getResults">
              {{$t("service_download.result.show_results")}}
            </button>
          </div>
        </div>
      </div>

    </div>

    <service-downloads-results :results="results"></service-downloads-results>

  </div>
</template>

<script>

import Mocks from '../Mocks'
import ServiceDownloadsResults from "./ServiceDownloadsResults";
import ServiceDownloadsProducts from "./ServiceDownloadsProducts";
import axios from 'axios';
import Loader from "./Loader";
import lodash from 'lodash';

let scrollOptions = {
  force: false,
  cancelable: true,
  offset: -200
};

const CancelToken = axios.CancelToken;
const resultCountCancel = CancelToken.source();


export default {
  name: "ServiceDownloads",
  components: {
    ServiceDownloadsResults,
    ServiceDownloadsProducts,
    Loader
  },
  data: function () {
    return {
      init: false,
      //categories: [],
      selection: [],
      resultsCount: null,
      filterSelection: [],
      triggerSearch: false,
      facets: null,
      loading: {
        categories: true,
        types: true,
        results: false,
        resultsCount: false,
        filter: true
      }
    }
  },
  computed: {
    results() {
      console.log('updated results');
      return this.$store.state.results;
    },
    categories() {
      if (!this.$store.state.categories)
        return [];
      return [].concat(this.$store.state.categories[0].children, this.$store.state.categories[1]);
    },
    filter() {
      if (!this.$store.state.filter) {
        return null;
      }
      let $this = this;

      if (!$this.facets || !this.facets.terms.type_id)
        return null;

      return this.$store.state.filter.type.filter((i) => {
        return this.facets.terms.type_id.indexOf(i.id) >= 0
      });
    },
    selectionLevel() {
      const category = this.selection[this.selection.length - 1];
      if (!this.hasChildren(category)) {
        return this.selection.length - 2;
      }
      return this.selection.length - 1;
    },
    hasValidSelection() {
      return this.selection.length > 1 || (!!this.selection[0] && !this.selection[0].children.length);
    }
  },
  watch: {
    'loading.types': function (newVal, oldVal) {
      console.log('loading changes from ' + oldVal + ' to ' + newVal);

      if (newVal == false && this.triggerSearch) {
        this.triggerSearch = false;
        this.getResults();
        console.log("Emit search");
      }
    },
    selection() {
      var $this = this;
      this.loading.types = true;
      this.throttleResultCount($this);

      this.$nextTick(() => {
        let level = 0;
        if ($this.selection.length > 0 && !$this.hasChildren($this.selection[$this.selection.length - 1])) {
          level = Math.max(0, $this.selection.length - 1);
        } else {
          level = $this.selection.length;
        }

        let elem = $this.$refs["categorie-level" + (level)];
        if (elem && !$this.loading.categories) {
          $this.$scrollTo(elem, 800, scrollOptions);
        }
      });


      this.updateRoute();
    },
    filterSelection() {
      let $this = this;
      $this.throttleResultCount($this);
      this.updateRoute();
    },
  },
  methods: {
    resetFilterSelection() {
      console.log("Reset filter selection");
      this.filterSelection.splice(0, this.filterSelection.length)
    },
    throttleResultCount: lodash.debounce(($this) => {


      if ($this.hasValidSelection) {
        console.log('update results');
        $this.getResultsCount();
      } else {
        $this.resultsCount = null;
      }

    }, 800),

    selectionBack(level) {
      this.selection.splice(level);
    },
    getSelectionPath() {
      const selectionPath = [];

      this.selection.forEach(function (item, i) {
        selectionPath.push(item.id);
      });

      return selectionPath;
    },
    updateRoute() {
      if (!this.init)
        return;

      console.log("update route");
      this.$router.push({
        name: 'downloads',
        params: {selection: this.getSelectionPath()},
        query: {filter: this.filterSelection}
      })
    },
    getResultsCount() {
      let promise = this.getResults(true);
      let self = this;

      promise.then((result) => {
        self.resultsCount = result.document_count;
        self.facets = result.facets;
        self.loading.resultsCount = false;
        self.loading.types = false;
      }).catch((thrown) => {
        console.error('Request Error', thrown);
      });

      // let $this = this;
      // this.loading.resultsCount = true;
      // //this.loading.types = true;
      //
      // let filterSelection = [];
      //
      // if($this.filter){
      //     let currentFilter = $this.filter.map((f) => f.id);
      //     filterSelection = $this.filterSelection.filter((f) => {
      //         return currentFilter.indexOf(f) !== -1;
      //     });
      // }
      //
      //
      // return new Promise((resolve, reject) => {
      //     axios.post(process.env.VUE_APP_API_BASE + '/api/service/downloads/results/count', {
      //         'filter': filterSelection,
      //         'selection': $this.getSelectionPath(),
      //
      //     }, {
      //         'cancelToken': resultCountCancel.token
      //     }).then((response) => {
      //         $this.resultsCount = response.data.document_count;
      //         $this.facets = response.data.facets;
      //         $this.loading.resultsCount = false;
      //         $this.loading.types = false;
      //         resolve();
      //     }).catch((thrown) => {
      //         if (axios.isCancel(thrown)) {
      //             console.log('Request canceled', thrown.message);
      //         } else {
      //             console.error('Request Error', thrown.message);
      //         }
      //     });
      //     resolve();
      // })
    },
    getResults(onlyCount) {
      let $this = this;
      // todo: add input timeout, to minimize request on filter selection
      $this.$store.commit('resultsStatus', 'loading');

      let currentFilter = [];

      if ($this.filter)
        currentFilter = $this.filter.map((f) => f.id);

      let filterSelection = $this.filterSelection.filter((f) => {
        return currentFilter.indexOf(f) !== -1;
      });

      let $data = {
        'filter': filterSelection,
        'selection': $this.getSelectionPath()
      };


      let promise;
      if (onlyCount === true) {
        promise = $this.$store.dispatch('getResultsCount', $data);
      } else {
        promise = $this.$store.dispatch('getResults', $data);
      }

      $this.$store.commit('searchFilterSelection', {"type_id": filterSelection});

      return promise;
      //$this.$store.dispatch('getResults', $data);
      // return new Promise((resolve, reject) => {
      //     axios.post(process.env.VUE_APP_API_BASE + '/api/service/downloads/results', {
      //         'filter': $this.filterSelection,
      //         'selection': $this.getSelectionPath()
      //     }).then((response) => {
      //         $this.results = response.data.results;
      //         $this.resultsCount = response.data.document_count;
      //         $this.$store.commit('results', this.results);
      //         $this.$store.commit('resultsStatus', 'finished');
      //         $this.loading.resultsCount = false;
      //         resolve();
      //     });
      //
      // })
    },
    getCategories() {
      let $this = this;
      let result = this.$store.dispatch('fetchCategories');
      return result;
    },
    getFilter() {
      let $this = this;
      return this.$store.dispatch('fetchFilters');
    },
    selectCategory(category) {
      if (category.link) {
        let linkedCategory = this.$store.getters.findCategoryById(category.link)

        if (linkedCategory) {
          category = linkedCategory;
        }

        let path = category.node_id.replace('/165487/', '').split('/');

        this.selectCategoryByPath(path);
      }
      let level = this.getCategoryLevel(category);
      let selection = this.selection.splice(level, this.selection.length, category);

    },
    getChildren(category) {
      if (category && category.children) {
        let children = category.children.filter((i) => !i.visibility || i.visibility.length == 0 || i.visibility.indexOf('downloads') >= 0);
        return children
      }

      return [];
    },
    hasChildren(category) {
      var children;
      if (!category || !(children = this.getChildren(category)) || !children.length)
        return false;

      return true;
    },
    getCategoryLevel(category) {
      if (!category)
        return null;
      return Math.max(category.directory.replace(/\/$/, "").split('/').length - 2, 0);
    },
    getCategoryById(id, parent = null) {
      parent = parent === null ? parent = this.categories : parent.children;
      return parent.find(function (elem) {
        return parseInt(elem.id) === parseInt(id);
      });
    },
    getFilterById(id) {
      if (!!this.$store.state.filter && !!this.$store.state.filter.type)
        return this.$store.state.filter.type.find((elem) => (elem.id === id));
      return null;
    }
    ,
    selectCategoryByPath(path) {
      let current = null;
      for (var i = 0; i < path.length; i++) {
        current = this.getCategoryById(path[i], current);
        if (current)
          this.selectCategory(current);
        else
          break;
      }
    },
    getFilterSelectionFromRoute() {
      let $this = this;
      const $q = $this.$route.query;

      if (!$q.filter) {
        return;
      }

      if (!Array.isArray($q.filter) && $this.getFilterById($q.filter)) {
        $this.filterSelection.push($q.filter);
        $this.triggerSearch = true;
      } else {
        $q.filter.forEach(function (elem) {
          const filter = $this.getFilterById(elem);
          if (filter)
            $this.filterSelection.push(elem);
        });

        $this.triggerSearch = true;
      }


      $this.loading.filter = false;

    }

  },
  mounted() {
    console.log("Mounted Service Downloads");
    this.$scrollTo(this.$el, 800, scrollOptions);
  },
  created: function () {
    const $this = this;
    this.$store.commit('selectService', "downloads");
    Promise.all([this.getCategories(), this.getFilter()]).then(values => {

      const selection = $this.$attrs.selection;

      console.log('adding url filter');
      if (selection) {
        $this.selectCategoryByPath(selection);
      }

      $this.loading.categories = false;

      // this.$nextTick(() => {
      //     $this.$scrollTo($this.$el, 800, scrollOptions)
      // });
      $this.getFilterSelectionFromRoute();
      $this.init = true;

    });

  }

}
</script>

<style>
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all .3s ease;
}

.slide-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter
  /* .slide-fade-leave-active below version 2.1.8 */
{
  transform: translateX(10px);
  opacity: 0;
}

.slide-fade-leave-to {

}

.list-enter-active, .list-leave-active {

}

.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */
{

}

@media (max-width: 768px) {
  .category-enter-active {
    transition: all .3s ease;
  }

  .category-enter {
    opacity: 0;
  }

  .category-enter-to {
    opacity: 1;
  }

  .slide-fade-leave-active {
    transition: all .3s ease;
  }

  .category-leave {
    opacity: 1;
  }

  .category-leave-to {
    opacity: 0;
  }


}

.categories .service-list-item figure {
  background-color: #ccc;

}
</style>
